import https from "./https";
import store from "@/store";

const serverTaskLog = {
  getServerTaskLogs(params) {
    const organization = store.state.general.organization;
    const searchParams = new URLSearchParams(params);

    return https.get(
      `/admin/organizations/${organization.id}/server-task-logs?${searchParams}`
    );
  },
  getServerTaskLogCategories(params = {}) {
    const organization = store.state.general.organization;
    const searchParams = new URLSearchParams(params);

    return https.get(
      `/admin/organizations/${organization.id}/server-task-logs/categories?${searchParams}`
    );
  }
};

export default serverTaskLog;
